import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Kundorder } from "../../models/KundorderListResponseDTO";
import { KundorderSearchResultViewModel } from "./kundorder-search-result-view-model";

@Component({
    selector: "rask-kundorder-list",
    templateUrl: "./kundorder-list.component.html",
    styleUrls: ["./kundorder-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        RouterLink,
        TranslatePipe
    ]
})
export class KundorderListComponent {
    detailsUrl = "kundorderDetail";
    kundordrar: KundorderSearchResultViewModel[];
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("kundordrar") set list(val: Kundorder[]) {
        if (!val) {
            return;
        }
        this.kundordrar = val.map(x => new KundorderSearchResultViewModel(x));
    }
}
